// Plain feature checks: the formatjs should-polyfill helpers bundle their locale data into
// the entry point, which every visitor downloads to learn that no polyfill is needed.
function should() {
    return (
        typeof window.Intl === 'undefined' ||
        typeof window.Intl.Locale === 'undefined' ||
        typeof window.Intl.PluralRules === 'undefined' ||
        typeof window.IntersectionObserver === 'undefined' ||
        typeof window.ResizeObserver === 'undefined'
    );
}

export default should;
